
import Vue from 'vue'
import EditorBtn from '@/product/components/EditorBtn.vue'
import AddToCartBtn from '@/product/components/AddToCartBtn.vue'
import OutOfStock from '@/product/components/OutOfStock.vue'
import { EVENT_LABELS, EVENT_ACTIONS } from '@/common/utils'

export default Vue.extend({
  components: {
    EditorBtn,
    AddToCartBtn,
    OutOfStock
  },
  props: {
    elementPosition: {
      type: String,
      required: false,
      default:''
    }
  },
  data: function() {
    return {
      dataLabels: {
        UPPER : EVENT_LABELS.MOBILE_THREE_COLUMN_UPPER,
        LOWER : EVENT_LABELS.MOBILE_THREE_COLUMN_LOWER
      }
    }
  },
  computed: {
    eventAction() {
      return EVENT_ACTIONS.PROCEED
    },
    eventLabel() {
      return window.innerWidth <= 1024 ? this.dataLabels[this.elementPosition] : EVENT_LABELS.PC_THREE_COLUMN_UPPER
    },
    isOrderPlainProduct(): boolean {
      return this.$store.state.isOrderPlainProduct
    },
    hasStock(): boolean {
      return this.$store.getters.hasStock
    }
  },
  methods: {
    handleValidateQuantity() {
      this.$emit('validateQuantity')
    }
  }
})
